import Select from "react-select";

const SelectBox = ({ options, defaultValue, onChange, type }) => {
  const lightStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#3a3939",
      boxShadow: "none",
      border: 0,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      cursor: "pointer",
      backgroundColor: isSelected ? "#49494b" : "#3a3939",
      color: isSelected ? "#cccccc" : "#989898",
      "&:hover": {
        backgroundColor: "#49494b",
        color: "#cccccc",
      },
    }),

    singleValue: (provided) => {
      return { ...provided, color: "#cccccc" };
    },

    menu: (styles) => ({
      ...styles,
      backgroundColor: "#49494b",
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      color: "#989898",
      "&:hover": {
        color: "white",
      },
    }),
  };

  const darkStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#202020",
      boxShadow: "none",
      border: 0,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      cursor: "pointer",
      backgroundColor: isSelected ? "#3a3939" : "#202020",
      color: isSelected ? "#cccccc" : "#989898",
      "&:hover": {
        backgroundColor: "#3a3939",
        color: "#cccccc",
      },
    }),

    singleValue: (provided) => {
      return { ...provided, color: "#989898" };
    },

    menu: (styles) => ({
      ...styles,
      backgroundColor: "#202020",
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      color: "#989898",
      "&:hover": {
        color: "#989898",
      },
    }),
  };

  return (
    <Select
      options={options}
      styles={type === "light" ? lightStyles : darkStyles}
      defaultValue={defaultValue}
      onChange={onChange}
    />
  );
};

export default SelectBox;
